import axios from 'axios'

class ProceduresService {
  constructor(apiUrl){
    this.apiUrl = apiUrl
  }

  /**
  * @author Edgar Escobedo
  * @description POST create procedure
  * @date 11-03-2024
  * @param {String} nameProcedure
  * @param {Number} procedureUserId
  * @param {Number}  statusApplicationTypeId
  * @param {Date}  startDate
  * @param {Date}  limitDate
  * @param {String} token
  * @returns {Object}
  * @memberof ProcedureUserService
  */
  async createProcedure(nameProcedure, procedureUserId, statusApplicationTypeId, startDate, limitDate, token){
    let response = await axios.post(
      `${this.apiUrl}/procedure`,
        { nameProcedure, procedureUserId, statusApplicationTypeId, startDate, limitDate },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;   
  }
}

export { ProceduresService as default }